import { FC, useContext } from 'react'

import { TreeModalContext } from '@components/modals/TreeModal'
import ModalActionButton from '@components/modals/ModalActionButton'
import ResourcePermissions from '../../components/ResourcePermissions'

type Props = {
  resourceId: string | number
  resourceType: string
}

const StartStep: FC<Props> = props => {
  const { resourceId, resourceType } = props

  const context = useContext(TreeModalContext)
  const navigateTo = (stepId: string) => {
    if (context) {
      context.navigateTo(stepId)
    }
  }

  return (
    <>
      <div className="p">
        <ResourcePermissions resourceId={resourceId} resourceType={resourceType} />
      </div>
      <div>
        <ModalActionButton onClick={() => navigateTo('userPermissions')} label="Give user access" />
        <ModalActionButton onClick={() => navigateTo('groupPermissions')} label="Give group access" />
      </div>
    </>
  )
}

export default StartStep
